const execute = async (apiCall: any, path: string, payload?: any) => {
    try {
        const response = await apiCall(path, payload);
        if (response.body instanceof ReadableStream) {
            try {
                const body = await response.json();
                return {
                    ...payload,
                    data: body,
                };
            } catch (error: any) {
                return {
                    ...payload,
                    ...error,
                };
            }
        }
        return {
            ...payload,
            ...response,
        };
    } catch (error: any) {
         
        throw {
            ...payload,
            ...error,
        };
    }
};

export default execute;
